module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAASCAYAAACJgPRIAAAA+UlEQVQokXXPIUtEQRTF8f+OYBU/wGJe148gG+xvk2DT5BxtgsbdJJZFBItyxKBVk5hNr2rSYLQ9BAWbIMIYfILsm3dhuDD8uPdcYowvMca5lBJtLwALwKOkWVoqAAOgCzy0ItslsAYsSbprm4TtK2ATWJF0nUU1PAdGwKqk0yyq4QFwBGxJ2v/776SUGhkkXQLrwI7t4yyq4QmwDYxCVvzWW93ns6jOMwYmtvca6yTtAofAmW01gkvaAC6AW9vDxnWShsANUNoe/J/eSSkhaRkogWfbvemMM1VV9YF74BVYLIriexoF4An4Avq2P3PXBuAD6Nl+zwGAH5bjcniIvSr4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/more.png
// module id = mSa5
// module chunks = 89